import React, { Component } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import noMoney from '../../assets/noMoney.png'
import stopwatch from '../../assets/stopwatch.png'
import bell from '../../assets/bell.png'
import man from '../../assets/man.jpg'
import styled from 'styled-components'
import Image from 'react-bootstrap/Image'
import "./generalScreens.css"
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FaArrowAltCircleRight } from 'react-icons/fa';


const StyledContainer = styled(Container)`
  padding-right:0;
  padding-left:0;
  margin-right:0;
  margin-left:auto;
  overflow: hidden;
  min-height: 93vh;
  position: absolute;
  background-image: url(${man});
  background-size: 100% auto;
`

const SloganArea = styled.h2`
  color: black;
`
const SupportingArea = styled.h3`
  color: rgb(29, 185, 84);
  padding-bottom: 2%;
`

const TopBuffer = styled(Row)`
  padding-top: 10%;
`
const MiddleBuffer = styled(Row)`
  padding-top: 19%;
`

const Highlights = styled(Row)`
  background-color: rgba(29, 185, 84, 0.6);
  align-items: center;
  text-align: center;
  max-height: 25%;
  border: 5%;
  position: absolute;
  bottom: 0;
`

const Illustrations = styled(Image)`
  height: 15%;
  width: 15%;
`

const Features = styled.p`
  text-align: center;
  width: 25%;
`

const ImageRow = styled(Row)`
  justify-content: center;
  align-items: center;
`

const FormCol = styled(Col)`
  padding-bottom: 10%;
`

const FormLabel = styled(Form.Label)`
  color: black;
  padding: 1px;
  border: 2px;
  width: 100%;
`

const TitleRow = styled(Row)`
  background-color: rgb(256,256,256,0.5);
  justify-content: center;
`

const FormControl = styled(Form.Control)`
  background-color: rgba(0,0,0,0);
  border-top: none;
  outline-color: rgb(29, 185, 84);
  border-right: none;
  border-left: none;
`

const SubmitButton = styled(Button)`
  background-color: rgb(29, 185, 84);
  outline-color: rgb(29, 185, 84);
`

export default class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			eventName: '',
			error: null,
		};
	}



	render() {

		return (
			<StyledContainer fluid>
				<TopBuffer />
				<Col>
					<TitleRow>
						<SloganArea>Stop Paying Eventbrite Fees</SloganArea>
					</TitleRow>
					<TitleRow>
						<SupportingArea>Keep your money!</SupportingArea>
					</TitleRow>
				</Col>
				<Row>
					{/* <FormCol md={{ span: 6, offset: 3 }}>
						<Form onSubmit={this.onSubmit}>
							<Form.Group className='form-group' controlId="eventName">
								<FormLabel className='form-item'>What will you name your event?</FormLabel>
								<input
									className='form-item'
									type='text'
									placeholder='ex: X-Sell'
									value={this.state.eventName}
									onChange={(text) => {
										this.setState({ eventName: text.target.value });
									}}
								/>
							</Form.Group>
							<Link to={{
								pathname: "/create-event",
								data: {
									eventName: this.state.eventName
								}
							}}>
								<SubmitButton type="submit" variant='success'>
									Finish <FaArrowAltCircleRight />
								</SubmitButton>
							</Link>

						</Form>
					</FormCol> */}
				</Row>

				<Highlights>
					<Col xs={6} md={4}>
						<ImageRow>
							<Illustrations roundedCircle fluid src={noMoney} />
						</ImageRow>
						<ImageRow>
							<Features>No Ticketing Fee</Features>
						</ImageRow>
					</Col>
					<Col xs={6} md={4}>
						<ImageRow>
							<Illustrations roundedCircle fluid src={bell} />
						</ImageRow>
						<ImageRow>
							<Features>Promote To Our Users Near You With Notifications</Features>
						</ImageRow>
					</Col>
					<Col xs={6} md={4}>
						<ImageRow>
							<Illustrations roundedCircle fluid src={stopwatch} />
						</ImageRow>
						<ImageRow>
							<Features>Eliminate Lines</Features>
						</ImageRow>
					</Col>
				</Highlights>
			</StyledContainer>
		)
	}
}




